import React, { useContext } from 'react'
import { withRouter } from 'react-router-dom'
import SidebarContext from './SidebarContext'

const SidebarSubmenu = ({ title, items, history, location, onNavigate }) => {
  const { logout } = useContext(SidebarContext)

  const handleClick = (e, item) => {
    e.preventDefault()
    if (item.disabled) return
    if (item.action === 'logout') {
      if (onNavigate) onNavigate()
      if (logout) logout()
      return
    }
    if (!item.url || item.url === '#') return
    history.push(item.url)
    if (onNavigate) onNavigate()
  }

  return (
    <div className="app-sidebar__submenu" onMouseDown={(e) => e.stopPropagation()}>
      <div className="app-sidebar__submenu-title">{title}</div>
      <ul className="app-sidebar__submenu-list">
        {items.map((child) => {
          const isActive =
            !child.disabled && child.url && child.url !== '#'
              ? location.pathname.startsWith(child.url)
              : false
          const className = [
            'app-sidebar__submenu-item',
            child.disabled ? 'is-disabled' : '',
            isActive ? 'is-active' : ''
          ]
            .filter(Boolean)
            .join(' ')
          return (
            <li key={child.key || child.name} className={className}>
              <a href={child.url || '#'} onClick={(e) => handleClick(e, child)}>
                {child.name}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default withRouter(SidebarSubmenu)
